export default __webpack_public_path__ + "static/media/loginBg.5a53e48e.png";